<!-- Application Shell -->
<mat-sidenav-container id="LOSx-shell-container" autosize>
  <!-- Sidenav -->
  <mat-sidenav
    #sidenav
    class="sidebar-panel"
    [ngClass]="{
      'sidebar-full': !sidenavCollapsed,
      'sidebar-compact': sidenavCollapsed
    }"
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false"
  >
    <LOSx-sidenav [sidenavCollapsed]="sidenavCollapsed"></LOSx-sidenav>
  </mat-sidenav>

  <!-- Content -->
  <mat-sidenav-content class="sidenav">
    <!-- Toolbar -->
    <LOSx-toolbar [sidenav]="sidenav" (collapse)="toggleCollapse($event)"></LOSx-toolbar>
    <!-- Progress Bar -->
    @if (progressBarMode !== 'none') {
      <div>
        <div class="loading"></div>
      </div>
    }

    <!-- Breadcrumb -->
    <LOSx-breadcrumb></LOSx-breadcrumb>
    <!-- Content -->
    <LOSx-content></LOSx-content>
    <!-- Footer -->
    <LOSx-footer [styleClass]="'main-page'"></LOSx-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
